<nuc-loading></nuc-loading>

@if(showHeader) {
<nuc-header pagePath="{{ currentPagePath }}"></nuc-header>
<nuc-breadcrumb></nuc-breadcrumb>
}
<router-outlet />
@if(showFooter) {
<nuc-footer pagePath="{{ currentPagePath }}"></nuc-footer>
}